var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9115 12.0003L19.1886 17.2822C19.579 17.6729 19.5787 18.306 19.188 18.6964C18.7973 19.0867 18.1641 19.0864 17.7738 18.6957L12.4963 13.4135L7.20658 18.6953C6.81577 19.0856 6.1826 19.0851 5.79237 18.6943C5.40213 18.3035 5.4026 17.6703 5.79342 17.2801L11.0827 11.9986L5.79565 6.70679C5.4053 6.31609 5.40559 5.68292 5.79629 5.29257C6.18699 4.90223 6.82016 4.90251 7.2105 5.29321L12.498 10.5855L17.7739 5.31734C18.1648 4.92711 18.7979 4.92758 19.1881 5.31839C19.5784 5.70921 19.5779 6.34237 19.1871 6.73261L13.9115 12.0003Z",
    fill: "#171725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.063dcff7d6c96ed1bc53bec2a8ab6d20.svg";
export { ForwardRef as ReactComponent };